// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RadioTabs {
  display: flex;
  align-items: center;
  gap: 4px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 9999px;
  background-color: var(--color_neutral_0);
  padding: 4px;
  margin: 0;
  border: none;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.RadioTabs .RadioTabs-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 4px 12px;
  border-radius: 9999px;
  background-color: transparent;
  font-size: 12px;
  font-weight: 400;
  color: var(--color_neutral_800);
  transition: background-color 0.16s, color 0.16s;
}
.RadioTabs .RadioTabs-tab:hover {
  cursor: pointer;
}
.RadioTabs input[type=radio] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
}
.RadioTabs input[type=radio]:checked + .RadioTabs-tab {
  background-color: var(--color_neutral_900);
  color: var(--color_neutral_0);
}
.RadioTabs input[type=radio]:not(:checked, :disabled) + .RadioTabs-tab:hover {
  background-color: var(--color_neutral_200);
}
.RadioTabs input[type=radio]:not(:checked, :disabled) + .RadioTabs-tab:active {
  background-color: var(--color_neutral_400);
}
.RadioTabs input[type=radio]:disabled + .RadioTabs-tab {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/RadioTabs/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,qBAAA;EACA,wCAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,wBAAA;KAAA,qBAAA;UAAA,gBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,+CACE;AAAN;AAGI;EACE,eAAA;AADN;AAKE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;AAHJ;AAKI;EACE,0CAAA;EACA,6BAAA;AAHN;AAKI;EACE,0CAAA;AAHN;AAKI;EACE,0CAAA;AAHN;AAKI;EACE,YAAA;EACA,mBAAA;AAHN","sourcesContent":[".RadioTabs {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: fit-content;\n  border-radius: 9999px;\n  background-color: var(--color_neutral_0);\n  padding: 4px;\n  margin: 0;\n  border: none;\n  appearance: none;\n\n  .RadioTabs-tab {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 28px;\n    padding: 4px 12px;\n    border-radius: 9999px;\n    background-color: transparent;\n    font-size: 12px;\n    font-weight: 400;\n    color: var(--color_neutral_800);\n    transition:\n      background-color 0.16s,\n      color 0.16s;\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  input[type='radio'] {\n    position: absolute;\n    opacity: 0;\n    width: 0;\n    height: 0;\n    margin: 0;\n\n    &:checked + .RadioTabs-tab {\n      background-color: var(--color_neutral_900);\n      color: var(--color_neutral_0);\n    }\n    &:not(:checked, :disabled) + .RadioTabs-tab:hover {\n      background-color: var(--color_neutral_200);\n    }\n    &:not(:checked, :disabled) + .RadioTabs-tab:active {\n      background-color: var(--color_neutral_400);\n    }\n    &:disabled + .RadioTabs-tab {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
